import { render, staticRenderFns } from "./ProductCreatePage.vue?vue&type=template&id=3be827e6&scoped=true"
import script from "./ProductCreatePage.vue?vue&type=script&lang=js"
export * from "./ProductCreatePage.vue?vue&type=script&lang=js"
import style0 from "./ProductCreatePage.vue?vue&type=style&index=0&id=3be827e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be827e6",
  null
  
)

export default component.exports